import { render, staticRenderFns } from "./SocialNetworksList.vue?vue&type=template&id=ac73946c&lang=pug&"
import script from "./SocialNetworksList.vue?vue&type=script&lang=js&"
export * from "./SocialNetworksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports